/* eslint-disable */
import apiClient from '@data/apiClient';
import { USER_SUBSCRIPTION_STATES } from '../../../utils/constants';

export const fetchUserSubscriptionStatus = async (uuid) => {
  try {
    const response = await
    apiClient.get(
      `${process.env.GATSBY_SUBSCRIPTIONS_DOMAIN}${process.env.GATSBY_STRIPE_SUBSCRIPTION_API_PATH}?resource_id=${uuid}&most_active_and_recent=true`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );
    if (response.ok || response.status === 200) {
      return response?.data?.results[0]?.subscription_state
                || USER_SUBSCRIPTION_STATES.NOT_STARTED;
    }
  } catch (error) {
    return USER_SUBSCRIPTION_STATES.NOT_STARTED;
  }
};
